import styled from 'styled-components';
import { Flex, Box } from '@strapi/design-system';
export const Dropdown = styled.div`
  margin-top: 5px;
  max-height: 200px;
  overflow-y: auto;
  background: white;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 8px;
  z-index: 10;

  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #bbb;
  }
`;
export const DropdownItem = styled.div`
  height: 2.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2px;
  margin-bottom: 3px;
  cursor: pointer;
  border-radius: 6px;
  transition: background 0.3s ease;

  &:last-child {
    margin-bottom: 0;
  }

  &:hover {
    background: #f7f7f7;
  }

  .actions {
    display: flex;
    gap: 5px;

    button {
      background: ${({
  theme
}) => theme.colors.primary600};
      border: 1px solid ${({
  theme
}) => theme.colors.primary600};
      border-radius: 6px;
      padding: 6px 10px;
      cursor: pointer;
      font-size: 0.85rem;
      color: #ffffff;
      transition: background 0.3s ease, transform 0.2s ease;
    }

    button:hover {
      background: ${({
  theme
}) => theme.colors.primary500};
      transform: translateY(-2px);
    }

    button:active {
      transform: translateY(0);
    }
  }
`;
export const SearchBarWrapper = styled(Box)`
  margin-bottom: 0.5rem;
  margin-top: 1.1rem;
  width: 45%;
`;
export const CloseIconWrapper = styled(Flex)`
  transition: opacity 0.2s ease-in-out;
  opacity: ${({
  hidden
}) => hidden ? 0 : 1};
  svg path {
    fill: ${({
  theme
}) => theme.colors.neutral400};
  }
`;
export const SearchIconWrapper = styled(Flex)`
  cursor: pointer;
  font-size: 0.8rem;
  svg path {
    fill: ${({
  theme
}) => theme.colors.neutral800};
  }
`;